import { getEventDetail } from "@/apis/integration/log";
import { useQuery } from "@tanstack/react-query";
import { OrderCreateLogDetail } from "./OrderCreate";
import { IntegrationLogType } from "@/types";

type BasicInfoProps = {
  logId: number;
};

function useLogDetail(logId: number) {
  return useQuery({
    queryKey: ["integration-log", logId],
    queryFn: () => getEventDetail(logId),
  });
}

export default function LogDetail(props: BasicInfoProps) {
  const { logId } = props;
  const { data: log } = useLogDetail(logId);

  return (
    <div>
      {log?.type === IntegrationLogType.OrderCreate && (
        <OrderCreateLogDetail event={log} />
      )}
    </div>
  );
}
